import styles from './ErrorMessage.module.scss';
import { VdsIcon } from '@volt/volt-extended-components-react';

export interface ErrorMessageProps {
  message: string;
}

export default function ErrorMessage({ message }: ErrorMessageProps) {
  return (
    <div className={styles.error}>
      <div className={styles.error__highlight} />
      <span className={styles.error__icon}>
        <VdsIcon size="24px" color="red-500" svgIcon="error" />
      </span>
      <span className={styles.error__body}>
        <div className="body">{message}</div>
      </span>
    </div>
  );
}
